import { render, staticRenderFns } from "./SearchReader.vue?vue&type=template&id=637b24eb&"
import script from "./SearchReader.vue?vue&type=script&lang=ts&"
export * from "./SearchReader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports